import React from 'react';
import Modal from '../Modal';
import './styles.scss';

const component = (props) => (
  <Modal
    id="tocOverlay"
    isOpened={props.isOpened}
    onClose={props.onClose}
    persistent={false}
  >
    <h1 className="h2">PRIVACY POLICY</h1>

    <h2 className="h4">INTRODUCTION</h2>

    <p>
      <strong>
        Welcome to the 20 Lafayette LLC (“20 Lafayette”) website (the “Site”).
        20 Lafayette
      </strong>{' '}
      is committed to protecting the privacy of visitors to the Site. You (“You”
      or “Your” as applicable) should read and understand the following Privacy
      Policy (“Policy”). This Policy is intended to provide You with information
      regarding 20 Lafayette's collection, storage, use, and disclosure of Your
      personal information (“Information”). This Policy applies to all services
      available on the Site and does not apply to services or products offered
      by other companies or individuals, including third party sites made
      available through this Site. By using the Site, You consent to the
      collection and use of Your Information by 20 Lafayette as described in
      this Policy and the 20 Lafayette Terms and Conditions located at
      www.twotreesny.com, which is incorporated herein by reference and may
      include terms which are listed but not defined in this Policy.
    </p>
    <p>
      20 Lafayette may update this Policy in the future and 20 Lafayette
      reserves the right to revise this Policy at any time. Any such revisions
      shall be effective immediately upon notice thereof. Such notice may be
      provided by any means, including by posting a revised Policy. Your use of
      the Site subsequent to such notice shall be deemed acceptance by You of
      such revised Policy
    </p>

    <h2 className="h4">INFORMATION COLLECTED/ 3rd Party websites:</h2>
    <p>
      We collect both "Personal Information" and "Anonymous Information" about
      our users. "Personal Information" is information that can be used to
      contact or identify you or individuals about whom you enter information as
      part of your application on our Services, such as first name, last name,
      social security number, real estate license number, email address, phone
      number, street address, e-mail address, username and/or email address in
      combination with a password or security questions and answers, account
      numbers or credit/debit card numbers, even without a security code, access
      code, or password if the account could be accessed without such
      information, as well as information that is linked to the forgoing
      information.
    </p>
    <p>
      "Anonymous Information" is information that cannot be used to contact or
      identify an individual and is not linked to information that can be used
      to do so. It includes passively collected information about your
      activities on the Services, such as usage data, to the extent that
      information is not linked to your Personal Information
    </p>
    <p>
      Like most website and mobile app providers, we passively collect certain
      information from your devices, such as your IP address, browser
      information, unique device identifier (“UDID”) and/or your mobile
      operating system. We also collect geolocation data from Users that use the
      Services.
    </p>
    <p className="sub_header">a. Voluntarily submitted information</p>
    <ul>
      <li>
        We collect Personal Information that you voluntarily provide to us
        during your use of the Services, including when you subscribe to our
        broker listings, fill out the Contact Us form, contact an agent,
        schedule a tour of an available apartment, submit an application, enter
        information in the Services, make payments or otherwise manage your
        account with us through the Services.
      </li>
    </ul>
    <p className="sub_header">b. Information collected via technology</p>
    <ul>
      <li>
        We may collect information from your use of the Services, including your
        hardware model, browser type, operating system, Internet Protocol (IP)
        address and domain name. If you are using a mobile device, 20 Lafayette
        may also receive your UDID, or another unique identifier, and mobile
        operating system. We may correlate this information with other Personal
        Information we have about you. We may also use tools such as cookies to
        gather information as well. “Cookies” are small pieces of information
        that a website sends to your device while you are viewing the website.
        We use both session Cookies (which expire once you close your web
        browser), persistent Cookies (which stay on your device until you delete
        them) and third party Cookies (which are placed by a website from a
        domain other than ours) to provide you with a more personal and
        interactive experience. Persistent Cookies can be removed by following
        web browser help file directions. A “Pixel” is a snippet of code that
        collects information about a visitor’s behavior on a website, and then
        sends the information back to the originating platform to be processed
        and reported.
      </li>
      <li>
        Geolocation data: If you access the Services through a mobile device, we
        may access, collect, monitor and/or remotely store “geolocation data.”
      </li>
      <li>
        We use third party services, such as Google Analytics and Google Search
        Console, to track and analyze online behavior data of Users. In
        particular, we utilize features of Google Analytics called
        “Remarketing,” “Demographics and Interest Reporting” and “Ad Words.”
        These services enable us to use Google Analytics’ third-party audience
        data help inform, optimize, target and serve ads based your visits to
        our Website. We do this to better understand how you use the Services,
        with a view to offering improvements for all Users, and to tailor our
        business and marketing activities accordingly.
      </li>
      <li>
        If you would like to opt out of Google Analytics, please download and
        install the browser plugin at
        <a target="_blank" href="http://tools.google.com/dlpage/gaoptout?hl=en">
          http://tools.google.com/dlpage/gaoptout?hl=en
        </a>
        . Users can also opt out of third party interest based advertising by
        visiting the Network Advertising Initiative’s deactivation website at
        <a target="_blank" href="https://www.networkadvertising.org/choices/">
          www.networkadvertising.org/choices/
        </a>
        .
      </li>
    </ul>

    <h2 className="h4">USE OF INFORMATION COLLECTED</h2>
    <p>
      <strong>Personal Information</strong>
      <br />
      We may use you Personal Information for the following representative
      purposes:
    </p>
    <ul>
      <li>Schedule an apartment tour for you</li>
      <li>Send communications and administrative emails</li>
      <li>
        Process and evaluate information provided by you through the application
        process and contact you regarding the same
      </li>
      <li>Process information uploaded by you to our Services</li>
      <li>Process application, rent and other payments</li>
      <li>
        Send you information you request about the building, amenities and
        services
      </li>
      <li>
        Send you promotional/marketing information, newsletters, offers or other
        information from us or on behalf of our sponsors or partners
      </li>
      <li>Perform internal operations, including fraud detection</li>
      <li>
        Analyze, benchmark and conduct research on user data and interactions
        with the Services
      </li>
    </ul>

    <br />
    <p>
      <strong>Anonymous Information</strong>
      <br />
      We may use Anonymous Information for the following representative
      purposes:
    </p>
    <ul>
      <li>Perform internal operations on the Services</li>
      <li>Improve the Services and customize the user experience</li>
      <li>
        Aggregate the information collected via Cookies and Pixels to use in
        statistical analysis to help us track trends and analyze patterns
      </li>
    </ul>

    <h2 className="h4">SHARING AND DISCLOSING INFORMATION</h2>
    <p>
      We will not rent, sell or share your Personal Information with third
      parties except as specifically approved by you at the time of disclosure
      or under the circumstances described in this Privacy Policy.
    </p>
    <p>
      If you do not want us to use or disclose Personal Information collected
      about you in the ways identified in this Privacy Policy, you may choose
      not to use the Services or provide your Personal Information at any time.
    </p>
    <p>
      In addition to using the information collected by us for the purposes
      described in Section 2 above, we may also share your information as
      described below. Please review our sharing policy closely, especially with
      respect to your Personal Information.
    </p>
    <p>
      In addition, by downloading and using the Services, you agree to allow us
      to share your geolocation information.
    </p>
    <p className="sub_header">a. Service Providers</p>
    <ul>
      <li>
        We share Personal Information with vendors, consultants and other
        third-party service providers who perform services on behalf of - and at
        the request of – 20 Lafayette, including without limitation, companies
        that provide email services and host the Services, and third-party
        payment processors to enable the ability for you to make payments
        through the Services.
      </li>
      <li>
        20 Lafayette has selected companies who maintain high standards with
        respect to privacy and agree to use the Personal Information only to
        perform specific services on behalf of 20 Lafayette and in accordance
        with the terms and conditions of this Privacy Policy.
      </li>
    </ul>

    <p className="sub_header">
      b. Compliance with Laws, Law Enforcement and Safety
    </p>
    <ul>
      <li>
        We may disclose information we have collected about you if required to
        do so by law or if we, in our sole discretion, believe that disclosure
        is reasonable to comply with the law, requests or orders from law
        enforcement, or any legal process (whether or not such disclosure is
        required by applicable law), or to protect or defend 20 Lafayette's, or
        a third party's, rights or property.
      </li>
    </ul>
    <p className="sub_header">c. Aggregated Anonymous Information</p>
    <ul>
      <li>
        Aggregated Anonymous Information is the combination of your Anonymous
        Information with the Anonymous Information of other Users (“Aggregated
        Anonymous Information”). Aggregated Anonymous Information does not allow
        you to be identified or contacted. We may share such Aggregated
        Anonymous Information with third parties.
      </li>
    </ul>
    <p className="sub_header">d. Business Transactions</p>
    <ul>
      <li>
        We may share all or some of your Personal Information with any of our
        subsidiaries, joint venturers, or other companies under common control,
        in which case we will require them to honor this Privacy Policy.
      </li>
    </ul>

    <h2 className="h4">SECURITY OF YOUR INFORMATION</h2>
    <p>
      20 Lafayette uses commercially reasonable procedures to protect the
      Information collected through the Site. Please understand that no security
      system is perfect and, as such, 20 Lafayette does not guarantee the
      security of the Site, or that Your Information won’t be intercepted while
      being transmitted to the Site. We will make any legally required
      disclosures of any breach of the security, confidentiality, or integrity
      of your unencrypted electronically stored "personal data" or “personal
      information” (as defined in applicable state statutes on security breach
      notification) to you via email and/or conspicuous posting on the Website
      in the most expedient time possible and without unreasonable delay,
      insofar as it is consistent with (i) the legitimate needs of law
      enforcement or (ii) any measures necessary to determine the scope of the
      breach and restore the reasonable integrity of the data system.
    </p>
    <h2 className="h4">LINKS TO OTHER THIRD PARTY WEBSITES</h2>
    <p>
      Although the Site contains links to third party websites, 20 Lafayette is
      not responsible for the privacy policies and/or practices on those third
      party websites. Where 20 Lafayette has linked You to a third party website
      You should read the terms and conditions and privacy policy stated on that
      third party website as it governs the use of that third party website.
    </p>
    <h2 className="h4">CHILDRENS PRIVACY</h2>
    <p>
      The Site is directed to persons 18 years of age or older. Accordingly, You
      must be 18 years of age in order to access the Site. If You are under 18
      years of age You may not access the Site without the consent of a parent
      or guardian. 20 Lafayette does not knowingly collect, distribute or share
      any Information from persons under 18 years of age and 20 Lafayette is not
      under any obligation to verify that persons accessing the Site are, in
      fact, over 18 years of age. If 20 Lafayette becomes aware that a child
      under 18 years of age has provided Information to 20 Lafayette or the
      Site, 20 Lafayette will delete such Information as soon as is possible
      under the circumstances.
    </p>
    <h2 className="h4">TERMINATION</h2>
    <p>
      If you decide at any time that you no longer wish to receive the Services,
      please follow the unsubscribe instructions provided in any of the
      communications You receive. 20 Lafayette will delete Your 20 Lafayette ID
      and/or cease providing You with Services within thirty (30) days of
      receiving Your termination request and all of Your Information will be
      removed and no longer available on the Site. Please note that 20 Lafayette
      reserves the right to use Your Information in any aggregated data
      collection after termination, however 20 Lafayette will ensure that the
      use of such Information will not identify You personally.
    </p>
    <h2 className="h4">CALIFORNIA PRIVACY RIGHTS</h2>
    <p>
      Under California’s “Shine the Light” law, California residents have the
      right to request in writing from businesses with whom they have an
      established business relationship: (i) a list of the categories of
      Personal Information, such as name, address, e-mail address, and the type
      of services provided to that individual, that a business has disclosed to
      third parties (including affiliates that are separate legal entities)
      during the immediately preceding calendar year for the third parties’
      direct marketing purposes, and (ii) the names and addresses of all such
      third parties. To request the above information, California residents can
      email us at <a href="mailto:info@300ashland.com">info@300ashland.com</a>.
    </p>
    <h2 className="h4">QUESTIONS</h2>
    <p>
      If You have any questions concerning this Policy or the Site, please
      contact 20 Lafayette at{' '}
      <a href="mailto:info@300ashland.com">info@300ashland.com</a>. Effective
      Date: March 15th, 2023.
    </p>
  </Modal>
);

component.displayName = 'TermsAndConditionsModal';
export default component;



// WEBPACK FOOTER //
// ./client/components/TermsAndConditionsModal/index.js